import React from 'react';
import CountUp from 'react-countup';
import '../../css/numericCard.css';

const NumericCard = ({ data }) => {
    
    return (
        <div className="numeric-card-container">
            <h2>{data.title}</h2>
            <div className="numeric-info-container">

            {data.numericInfo?.map((info, index) => (
                <div key={info.id} className="numeric-card">
                    <div className="numeric-value">
                        <CountUp end={info.number} duration={5} className="numeric-value"/>
                    </div>
                    <div className="numeric-title">{info.title.trim()}</div>
                    {index < data.length - 1 && <div className="divider"></div>}
                
                </div>
                ))}
            </div>
        </div>

    );
};

export default NumericCard;
